import React, { PureComponent } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class NotFound extends PureComponent {
  render() {
    return (
      <Container className='dashboard'>
        <Row>
          <Col md={12}>
            <h3 className='page-title'>404 Page Not Found</h3>
          </Col>
        </Row>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/NotFound.js